import { appRoutes } from '@utils/consts';

export const oauthRoutes = [
  {
    path: appRoutes.oauthAuthorize,
    lazy: async () => {
      const { OauthAuthorize } = await import('@pages/oauth/authorize');
      return { Component: () => <OauthAuthorize /> };
    },
  },
];
